<script>
	import Breadcrumb from '../../../../components/Breadcrumb.svelte';
	import { onMount } from 'svelte';
	import { detectClickOutside } from '$lib/utils/detectClickOutside';
	export let data;
	let selected = 'none';
	import arrow from '$lib/images/volba-skutru/arrow.png';
	import ScooterSelectorNavigation from '../../../(components)/ScooterSelectorNavigation.svelte';
	let showList = false;

	let elm;

	onMount(function () {
		elm.focus();
		showList = true;
	});

	let filtered = [];
	let filterText = '';

	filtered = data.data;

	function filterProducer() {
		if (filterText == '') {
			filtered = data.data;
			return;
		}
		filtered = data.data.filter((item) => {
			return item.name.toLowerCase().includes(filterText.toLowerCase());
		});
	}

	const handleClickOutside = () => {
		showList = false;
	};
</script>

<svelte:head>
	<title>Skútry {data.producer.charAt(0).toUpperCase() + data.producer.slice(1)} {data.slug} ccm</title>
	<meta name="description" content="Vyberte model {data.producer} objem {data.slug} a objevte náhradní díly, technické údaje, návody a tipy"/>
	<link rel="canonical" href={`https://www.scootland.cz/skutry/${data.producer}/${data.slug}/`} />
	<meta property="og:title" content="Skútry {data.producer.charAt(0).toUpperCase() + data.producer.slice(1)} {data.slug} ccm" />
	<meta property="og:description" content="Vyberte model {data.producer} objem {data.slug} a objevte náhradní díly, technické údaje, návody a tipy"/>
	<meta property="og:image" content="/image/og-skutry.webp"/>
	<meta property="og:url" content="https://www.scootland.cz/skutry/{data.producer}/{data.slug}/"/>
	<meta property="og:suite_name" content="Scootland"/>
	<meta property="og:type" content="website" />
</svelte:head>


<Breadcrumb
	breadcrumbs={[
		{ name: 'Skútry', link: '/skutry' },
		{ name: data.producer.charAt(0).toUpperCase() + data.producer.slice(1), link: '/skutry/' + data.producer },
		{ name: data.slug !== '0' ? data.slug + ' ccm': 'elektro', link: data.slug }
	]}
/>

<section class="bg-graybg py-8">
	<div class="mx-auto w-full px-2 md:w-4/6 lg:px-0">
		<div class="container mx-auto">
			<div class="border-b border-gray-200">
				<h1 class="mb-6 pb-4 text-center text-2xl font-bold sm:text-3xl">
					Skútry {data.producer.charAt(0).toUpperCase() + data.producer.slice(1)} {data.slug} ccm
				</h1>
			</div>
		</div>

		<ScooterSelectorNavigation producer={data.producer.charAt(0).toUpperCase() + data.producer.slice(1)} step={2} />

		<div class="flex w-full">
			<div class="w-1/2 pr-2 md:pr-2">
				<div class="relative">
					<select
						disabled
						class="form-select px-4.5 focus:border-blue-600 m-0 block w-full appearance-none border-4 border-solid border-gray-300 bg-gray-300 bg-clip-padding bg-no-repeat py-3.5 indent-8 text-gray-700 transition ease-in-out focus:bg-white focus:text-gray-700 focus:outline-none"
					>
						<option>
							{#if data.slug == '0'}
								Elektro
							{:else}
								{data.slug} ccm
							{/if}
						</option>
					</select>
				</div>
			</div>
			<div class="w-1/2 pl-4 md:pl-2">
				<div class="relative">
					<input
						bind:this={elm}
						focused
						type="text"
						placeholder="Typ skútru"
						on:click={() => (showList = true)}
						bind:value={filterText}
						use:detectClickOutside
						on:click_outside={handleClickOutside}
						on:input={filterProducer}
						class="form-select px-4.5 border-primary focus:border-blue-600 m-0 block w-full appearance-none border-4 border-solid bg-white bg-clip-padding bg-no-repeat py-3.5 text-left indent-8 text-gray-700 transition ease-in-out focus:bg-white focus:text-gray-700 focus:outline-none"
					/>
					<div
						data-test="producers_list"
						class="{showList ? '' : 'hidden'} test focus:border-focusblue absolute w-full
       overflow-y-auto border-4 bg-white bg-clip-padding bg-clip-padding bg-no-repeat text-gray-700
      transition ease-in-out focus:bg-white focus:text-gray-700 focus:outline-none"
					>
						{#each filtered as item}
							<a
								id={item}
								href="/skutr-{item.url}/"
								class="w-100 flex cursor-pointer p-2 pl-5 transition hover:bg-gray-100"
							>
								{item.name}
							</a>
						{/each}
					</div>
				</div>
			</div>
		</div>
	</div>
</section>

<section class="shadow-top bg-white pt-16">
	<h2 class="mb-6 pb-4 text-center text-xl font-bold">
		Nepamatujete si váš model {data.producer} {data.slug}? Zkuste to podle obrázku níže!
		<img src={arrow} class="ml-2 inline-block" alt="" />
	</h2>
	<div class="container mx-auto border-b border-gray-200 px-5 pb-16">
		<div class="flex flex-wrap items-center">
			{#each data.data as scooter}
				<a
					class="my-8 w-1/2 border-b border-gray-200 text-center text-gray-500 md:w-1/4"
					data-sveltekit-preload-data="tap"
					href="/skutr-{scooter.url}/"
					title="Jdi na detail skútru {scooter.producer} {scooter.name} {scooter.ccm} ccm pro náhradní díly, technické údaje, rady a tipy"
				>
					<div class="p-4">
						<div class="w-full bg-gray-100 p-5">
							<img
								class="mb-6 w-full rounded object-cover object-center"
								src={scooter.main_image_new.url_medium}
								alt={scooter.main_image_new.alt}
							/>
						</div>
						<h2 class="mt-4 text-xl font-bold">
							{scooter.name}
						</h2>
						<h2 class="font-lg">
							{scooter.ccm !== "0" ? scooter.ccm + " ccm": "elektro"}
						</h2>
					</div>
				</a>
			{/each}
		</div>
	</div>
</section>
